module.exports = __webpack_public_path__ + "static/media/brand06.cc1d9127.png";